import { css } from "@emotion/css"
import { Checkbox, FormControlLabel } from "@material-ui/core"
import { useI18n } from "providers/I18n"

type Props = {
  tab?: string
  checked?: boolean
  onCheckBoxChange: VoidFunction
  disabled?: boolean
  section: string
}

export const TableColumnHeader = (props: Props) => {
  const { t } = useI18n()
  const { tab, checked, onCheckBoxChange, disabled, section } = props

  return (
    <table className={styles.tableHeader}>
      <thead>
        <tr role="row">
          <th>
            <FormControlLabel
              disabled={disabled}
              label={t("filters.all")}
              classes={{
                root: styles.formRoot,
                label: styles.formLabel,
              }}
              control={
                <Checkbox
                  key={`${section}.${tab}`}
                  color="primary"
                  checked={checked}
                  onChange={onCheckBoxChange}
                  className={styles.checkbox}
                />
              }
            />
          </th>
        </tr>
      </thead>
    </table>
  )
}

const styles = {
  tableHeader: css`
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;

    thead {
      tr {
        border-bottom: solid 2px var(--light-grey);
      }

      th,
      td {
        margin: 0;
        font-size: 14px;
        font-weight: normal;
        color: var(--grey);
        width: 40%;
        padding-left: 0;
        padding-bottom: 8px;
        text-align: start;
      }
    }
  `,
  formRoot: css`
    margin-right: 0;
    margin-left: 0;
  `,
  formLabel: css`
    font-size: 16px;
    color: var(--black);
  `,
  checkbox: css`
    padding: 0;
    margin-right: 9px;
    margin-left: -1px;
    .MuiIconButton-label {
      justify-content: flex-start;
    }
  `,
}
